<template>
  <TheMenuLayout>
    <BaseSectionHeader>
      Liste des Vidéos disponibles
    </BaseSectionHeader>

    <BaseList :items="items" />
    <BaseEmptyState v-if="!items.length">
      Aucunes Vidéos disponibles
    </BaseEmptyState>
  </TheMenuLayout>
</template>

<script>
import TheMenuLayout from '@/components/TheMenuLayout.vue';
import BaseSectionHeader from '@/components/BaseSectionHeader.vue';
import BaseList from '@/components/BaseList.vue';
import BaseEmptyState from '@/components/BaseEmptyState.vue';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'VideoList',
  components: {
    TheMenuLayout,
    BaseSectionHeader,
    BaseList,
    BaseEmptyState,
  },
  computed: {
    ...mapState(['videos']),
    items() {
      return this.videos.map((video) => ({
        title: video.title,
        key: video.id,
        icon: 'mdi-video',
        subtitles: [],
        onClick: () => {
          window.location.href = video.url;
        },
      }));
    },
  },
  methods: {
    ...mapActions(['fetchVideos']),
  },
  created() {
    this.fetchVideos();
  },
};
</script>
